<app-base-inline-form
  [header]="header()"
  [fields]="fields()"
  [model]="model"
  [labelsVertical]="labelsVertical()"
></app-base-inline-form>

<ag-grid-angular
  class="ag-grid {{ themeService.gridThemeClass() }} d-print-none {{ gridCssClass() }}"
  [class.d-none]="model.preview"
  [gridOptions]="gridOptions"
  [rowData]="rowData()"
  [pagination]="!model.preview"
  (rowDataUpdated)="rowDataUpdated()"
  (gridReady)="gridReady($event)"
>
</ag-grid-angular>

<ag-grid-angular
  domLayout="print"
  class="ag-grid {{ themeService.gridThemeClass() }} d-print-block {{ gridCssClass() }}"
  [class.d-none]="!model.preview"
  [gridOptions]="gridOptions"
  [rowData]="rowData()"
  [pagination]="false"
>
</ag-grid-angular>
